module.exports = __webpack_public_path__ + "img/65.8fcb9866.jpg";